'use client';

import _defineProperty from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _objectWithoutProperties from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js";
import _slicedToArray from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import _toConsumableArray from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import _taggedTemplateLiteral from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral.js";
var _excluded = ["className", "color", "disableShrink", "size", "style", "thickness", "value", "variant"];

var _templateObject, _templateObject2, _templateObject3, _templateObject4;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import * as React from 'react';
import clsx from 'clsx';
import chainPropTypes from '@mui/utils/chainPropTypes';
import composeClasses from '@mui/utils/composeClasses';
import { keyframes, css, styled } from "../zero-styled/index.js";
import memoTheme from "../utils/memoTheme.js";
import { useDefaultProps } from "../DefaultPropsProvider/index.js";
import capitalize from "../utils/capitalize.js";
import createSimplePaletteValueFilter from "../utils/createSimplePaletteValueFilter.js";
import { getCircularProgressUtilityClass } from "./circularProgressClasses.js";
import { jsx as _jsx } from "react/jsx-runtime";
var SIZE = 44;
var circularRotateKeyframe = keyframes(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  0% {\n    transform: rotate(0deg);\n  }\n\n  100% {\n    transform: rotate(360deg);\n  }\n"])));
var circularDashKeyframe = keyframes(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  0% {\n    stroke-dasharray: 1px, 200px;\n    stroke-dashoffset: 0;\n  }\n\n  50% {\n    stroke-dasharray: 100px, 200px;\n    stroke-dashoffset: -15px;\n  }\n\n  100% {\n    stroke-dasharray: 1px, 200px;\n    stroke-dashoffset: -126px;\n  }\n"]))); // This implementation is for supporting both Styled-components v4+ and Pigment CSS.
// A global animation has to be created here for Styled-components v4+ (https://github.com/styled-components/styled-components/blob/main/packages/styled-components/src/utils/errors.md#12).
// which can be done by checking typeof indeterminate1Keyframe !== 'string' (at runtime, Pigment CSS transform keyframes`` to a string).

var rotateAnimation = typeof circularRotateKeyframe !== 'string' ? css(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n        animation: ", " 1.4s linear infinite;\n      "])), circularRotateKeyframe) : null;
var dashAnimation = typeof circularDashKeyframe !== 'string' ? css(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n        animation: ", " 1.4s ease-in-out infinite;\n      "])), circularDashKeyframe) : null;

var useUtilityClasses = function useUtilityClasses(ownerState) {
  var classes = ownerState.classes,
      variant = ownerState.variant,
      color = ownerState.color,
      disableShrink = ownerState.disableShrink;
  var slots = {
    root: ['root', variant, "color".concat(capitalize(color))],
    svg: ['svg'],
    circle: ['circle', "circle".concat(capitalize(variant)), disableShrink && 'circleDisableShrink']
  };
  return composeClasses(slots, getCircularProgressUtilityClass, classes);
};

var CircularProgressRoot = styled('span', {
  name: 'MuiCircularProgress',
  slot: 'Root',
  overridesResolver: function overridesResolver(props, styles) {
    var ownerState = props.ownerState;
    return [styles.root, styles[ownerState.variant], styles["color".concat(capitalize(ownerState.color))]];
  }
})(memoTheme(function (_ref) {
  var theme = _ref.theme;
  return {
    display: 'inline-block',
    variants: [{
      props: {
        variant: 'determinate'
      },
      style: {
        transition: theme.transitions.create('transform')
      }
    }, {
      props: {
        variant: 'indeterminate'
      },
      style: rotateAnimation || {
        animation: "".concat(circularRotateKeyframe, " 1.4s linear infinite")
      }
    }].concat(_toConsumableArray(Object.entries(theme.palette).filter(createSimplePaletteValueFilter()).map(function (_ref2) {
      var _ref3 = _slicedToArray(_ref2, 1),
          color = _ref3[0];

      return {
        props: {
          color: color
        },
        style: {
          color: (theme.vars || theme).palette[color].main
        }
      };
    })))
  };
}));
var CircularProgressSVG = styled('svg', {
  name: 'MuiCircularProgress',
  slot: 'Svg',
  overridesResolver: function overridesResolver(props, styles) {
    return styles.svg;
  }
})({
  display: 'block' // Keeps the progress centered

});
var CircularProgressCircle = styled('circle', {
  name: 'MuiCircularProgress',
  slot: 'Circle',
  overridesResolver: function overridesResolver(props, styles) {
    var ownerState = props.ownerState;
    return [styles.circle, styles["circle".concat(capitalize(ownerState.variant))], ownerState.disableShrink && styles.circleDisableShrink];
  }
})(memoTheme(function (_ref4) {
  var theme = _ref4.theme;
  return {
    stroke: 'currentColor',
    variants: [{
      props: {
        variant: 'determinate'
      },
      style: {
        transition: theme.transitions.create('stroke-dashoffset')
      }
    }, {
      props: {
        variant: 'indeterminate'
      },
      style: {
        // Some default value that looks fine waiting for the animation to kicks in.
        strokeDasharray: '80px, 200px',
        strokeDashoffset: 0 // Add the unit to fix a Edge 16 and below bug.

      }
    }, {
      props: function props(_ref5) {
        var ownerState = _ref5.ownerState;
        return ownerState.variant === 'indeterminate' && !ownerState.disableShrink;
      },
      style: dashAnimation || {
        // At runtime for Pigment CSS, `bufferAnimation` will be null and the generated keyframe will be used.
        animation: "".concat(circularDashKeyframe, " 1.4s ease-in-out infinite")
      }
    }]
  };
}));
/**
 * ## ARIA
 *
 * If the progress bar is describing the loading progress of a particular region of a page,
 * you should use `aria-describedby` to point to the progress bar, and set the `aria-busy`
 * attribute to `true` on that region until it has finished loading.
 */

var CircularProgress = /*#__PURE__*/React.forwardRef(function CircularProgress(inProps, ref) {
  var props = useDefaultProps({
    props: inProps,
    name: 'MuiCircularProgress'
  });

  var className = props.className,
      _props$color = props.color,
      color = _props$color === void 0 ? 'primary' : _props$color,
      _props$disableShrink = props.disableShrink,
      disableShrink = _props$disableShrink === void 0 ? false : _props$disableShrink,
      _props$size = props.size,
      size = _props$size === void 0 ? 40 : _props$size,
      style = props.style,
      _props$thickness = props.thickness,
      thickness = _props$thickness === void 0 ? 3.6 : _props$thickness,
      _props$value = props.value,
      value = _props$value === void 0 ? 0 : _props$value,
      _props$variant = props.variant,
      variant = _props$variant === void 0 ? 'indeterminate' : _props$variant,
      other = _objectWithoutProperties(props, _excluded);

  var ownerState = _objectSpread(_objectSpread({}, props), {}, {
    color: color,
    disableShrink: disableShrink,
    size: size,
    thickness: thickness,
    value: value,
    variant: variant
  });

  var classes = useUtilityClasses(ownerState);
  var circleStyle = {};
  var rootStyle = {};
  var rootProps = {};

  if (variant === 'determinate') {
    var circumference = 2 * Math.PI * ((SIZE - thickness) / 2);
    circleStyle.strokeDasharray = circumference.toFixed(3);
    rootProps['aria-valuenow'] = Math.round(value);
    circleStyle.strokeDashoffset = "".concat(((100 - value) / 100 * circumference).toFixed(3), "px");
    rootStyle.transform = 'rotate(-90deg)';
  }

  return /*#__PURE__*/_jsx(CircularProgressRoot, _objectSpread(_objectSpread(_objectSpread({
    className: clsx(classes.root, className),
    style: _objectSpread(_objectSpread({
      width: size,
      height: size
    }, rootStyle), style),
    ownerState: ownerState,
    ref: ref,
    role: "progressbar"
  }, rootProps), other), {}, {
    children: /*#__PURE__*/_jsx(CircularProgressSVG, {
      className: classes.svg,
      ownerState: ownerState,
      viewBox: "".concat(SIZE / 2, " ").concat(SIZE / 2, " ").concat(SIZE, " ").concat(SIZE),
      children: /*#__PURE__*/_jsx(CircularProgressCircle, {
        className: classes.circle,
        style: circleStyle,
        ownerState: ownerState,
        cx: SIZE,
        cy: SIZE,
        r: (SIZE - thickness) / 2,
        fill: "none",
        strokeWidth: thickness
      })
    })
  }));
});
process.env.NODE_ENV !== "production" ? void 0 : void 0;
export default CircularProgress;